import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/admin',
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/Admin.vue'),
    redirect: '/admin/profiles',
    children: [
      {
        path: '/admin/profiles',
        name: 'AdminCourses',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/AdminCourses.vue'),
      },
      {
        path: '/admin/users',
        name: 'AdminUsers',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/AdminUsers.vue'),
      },
      {
        path: '/admin/questionsbank',
        name: 'AdminQuestionsBank',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/AdminQuestionsBank.vue'),
      },
      {
        path: '/admin/tasksBank',
        name: 'TasksBank',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/TasksBank.vue'),
      },
      {
        path: '/admin/videosbank',
        name: 'AdminVideosBank',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/AdminVideosBank.vue'),
      },
      {
        path: '/admin/booksbank',
        name: 'AdminBooksBank',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/AdminBooksBank.vue'),
      },
      {
        path: '/admin/coupons',
        name: 'AdminCoupons',
        component: () => import(/* webpackChunkName: "reportEntity" */ '@/views/Coupons.vue'),
      },
      {
        path: '/admin/files',
        name: 'AdminFiles',
        component: () => import(/* webpackChunkName: "reportEntity" */ '@/views/Files.vue'),
      },
      {
        path: '/admin/action/updateexerciselaws',
        name: 'AdminUpdateExerciseLaws',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/AdminUpdateExerciseLaws.vue'),
      },
      {
        path: '/admin/action/updateVideoContent',
        name: 'AdminUpdateVideoContent',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/AdminUpdateVideoContent.vue'),
      },
      {
        path: '/admin/action/updatelawcollections',
        name: 'AdminUpdateLawCollections',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/AdminUpdateLawCollections.vue'),
      },
      {
        path: '/admin/action/unitReplication',
        name: 'AdminUnitReplication',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/AdminUnitReplication.vue'),
      },
      {
        path: '/admin/action/verdictReplication',
        name: 'AdminVerdictReplication',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/AdminVerdictReplication.vue'),
      },
      {
        path: '/admin/action/createAnswersFiles',
        name: 'AdminCreateAnswersFiles',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/AdminCreateAnswersFiles.vue'),
      },
      {
        path: '/admin/action/createQuestionsFiles',
        name: 'AdminCreateQuestionsFiles',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/AdminCreateQuestionsFiles.vue'),
      },
      {
        path: '/admin/action/verdictscollections',
        name: 'AdminVerdictsCollections',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/AdminVerdictsCollections.vue'),
      },
      {
        path: '/admin/action/manageLawsCollections',
        name: 'AdminManageLawsCollections',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/AdminManageLawsCollections.vue'),
      },
      {
        path: '/admin/action/manageQuestionsCategories',
        name: 'AdminManageQuestionsCategories',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/AdminManageQuestionsCategories.vue'),
      },
      {
        path: '/admin/plannerRuns',
        name: 'AdminPlannerRuns',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/AdminPlannerRuns.vue'),
      },
    ],
  },
  {
    path: '/users',
    name: 'CourseUsers',
    component: () => import(/* webpackChunkName: "CourseUsers" */ '@/views/CourseUsers.vue'),
  },
  {
    path: '/courseMessages',
    name: 'CourseMessages',
    component: () => import(/* webpackChunkName: "profile" */ '@/views/CourseMessages.vue'),
  },
  {
    path: '/reports',
    name: 'CourseReports',
    component: () => import(/* webpackChunkName: "CourseReports" */ '@/views/CourseReports.vue'),
  },
  {
    path: '/requests',
    name: 'CourseRequests',
    component: () => import(/* webpackChunkName: "CourseRequests" */ '@/views/CourseRequests.vue'),
  },
  { path: "/CourseTasks", name: "CourseTasks", component: () => import("@/views/CourseTasks.vue") },
  {
    path: '/exercise/:id',
    name: 'Exercise',
    component: () => import(/* webpackChunkName: "ExerciseEntity" */ '@/views/ExerciseEntity.vue'),
  },
  {
    path: '/question/:id',
    name: 'Question',
    component: () => import(/* webpackChunkName: "QuestionEntity" */ '@/views/QuestionEntity.vue'),
  },
  {
    path: '/lawCollection/:id',
    name: 'LawCollection',
    component: () => import(/* webpackChunkName: "QuestionEntity" */ '@/views/LawCollectionEntity.vue'),
  },
  {
    path: '/newQuestion',
    name: 'NewQuestion',
    component: () => import(/* webpackChunkName: "QuestionEntity" */ '@/views/NewQuestion.vue'),
  },
  {
    path: '/lessons/:id',
    name: 'Lesson',
    component: () => import(/* webpackChunkName: "reportEntity" */ '@/views/LessonEntity.vue'),
  },
  {
    path: '/videos',
    name: 'Videos',
    component: () => import(/* webpackChunkName: "reportEntity" */ '@/views/Videos.vue'),
  },
  {
    path: '/books',
    name: 'Books',
    component: () => import(/* webpackChunkName: "reportEntity" */ '@/views/Books.vue'),
  },
  {
    path: '/exercises',
    name: 'Exercises',
    component: () => import(/* webpackChunkName: "reportEntity" */ '@/views/Exercises.vue'),
  },
  {
    path: '/laws',
    name: 'Laws',
    component: () => import(/* webpackChunkName: "reportEntity" */ '@/views/Laws.vue'),
  },
  {
    path: '/verdicts',
    name: 'Verdicts',
    component: () => import(/* webpackChunkName: "reportEntity" */ '@/views/Verdicts.vue'),
  },
  {
    path: '/groups',
    name: 'Groups',
    component: () => import(/* webpackChunkName: "reportEntity" */ '@/views/Groups.vue'),
  },
  {
    path: '/group/:id',
    name: 'GroupEntityPage',
    component: () => import(/* webpackChunkName: "reportEntity" */ '@/views/GroupEntity.vue'),
  },
  {
    path: '/exerciseAnswers',
    name: 'ExerciseAnswers',
    component: () => import(/* webpackChunkName: "reportEntity" */ '@/views/ExerciseAnswers.vue'),
  },
  {
    path: '/lecturesLearningTracks',
    name: 'LecturesLearningTracks',
    component: () => import(/* webpackChunkName: "reportEntity" */ '@/views/LecturesLearningTracks.vue'),
  },
  {
    path: '/lecturesRegions',
    name: 'LecturesRegions',
    component: () => import(/* webpackChunkName: "reportEntity" */ '@/views/LecturesRegions.vue'),
  },
  {
    path: '/lecturesHalls',
    name: 'LecturesHalls',
    component: () => import(/* webpackChunkName: "reportEntity" */ '@/views/LecturesHalls.vue'),
  },
  {
    path: '/lecturesTeachers',
    name: 'LecturesTeachers',
    component: () => import(/* webpackChunkName: "reportEntity" */ '@/views/LecturesTeachers.vue'),
  },
  {
    path: '/lecturesFeedbacksStatements',
    name: 'LecturesFeedbacksStatements',
    component: () => import(/* webpackChunkName: "reportEntity" */ '@/views/LecturesFeedbacksStatements.vue'),
  },
  {
    path: '/lectures/:id?',
    name: 'Lectures',
    component: () => import(/* webpackChunkName: "reportEntity" */ '@/views/Lectures.vue'),
  },
  {
    path: '/lecturesLearningTrack/:id/Subjects',
    name: 'LectureTrackSubjects',
    component: () => import(/* webpackChunkName: "reportEntity" */ '@/views/LectureTrackSubjects.vue'),
  },
  {
    path: '/course/:courseId/exercisePrint/:exerciseId?',
    name: 'ExercisePrint',
    component: () => import(/* webpackChunkName: "reportEntity" */ '@/views/ExercisePrint.vue'),
  },
  {
    path: '/expoChapters',
    name: 'ExpoChapters',
    component: () => import(/* webpackChunkName: "reportEntity" */ '@/views/ExpoChapters.vue'),
  },
  {
    path: '/expoChapter/:id',
    name: 'ExpoChapterPage',
    component: () => import(/* webpackChunkName: "reportEntity" */ '@/views/ExpoChapterEntity.vue'),
  },
  {
    path: '/expoChapter/:id/questions',
    name: 'ExpoChapterQuestions',
    component: () => import(/* webpackChunkName: "reportEntity" */ '@/views/ExpoChapterQuestions.vue'),
  },
  {
    path: '/user/:id',
    name: 'User',
    component: () => import(/* webpackChunkName: "UserEntity" */ '@/views/UserEntity.vue'),
  },
  {
    path: '/lessons',
    name: 'Lessons',
    component: () => import(/* webpackChunkName: "Lessons" */ '@/views/Lessons.vue'),
  },
  {
    path: '/course',
    name: 'Course',
    redirect: '/course/general',
    component: () => import(/* webpackChunkName: "profile" */ '@/views/Course.vue'),
    children: [
      {
        path: 'general',
        name: 'CourseGeneral',
        component: () => import(/* webpackChunkName: "profile" */ '@/views/CourseGeneral.vue'),
      },
      // {
      //   path: 'messages',
      //   name: 'CourseMessages',
      //   component: () => import(/* webpackChunkName: "profile" */ '@/views/CourseMessages.vue'),
      // },
      {
        path: 'navigation',
        name: 'CourseNavigation',
        component: () => import(/* webpackChunkName: "profile" */ '@/views/CourseNavigation.vue'),
      },
      {
        path: 'calendar',
        name: 'CourseCalendar',
        component: () => import(/* webpackChunkName: "profile" */ '@/views/CourseCalendar.vue'),
      },
      {
        path: 'admincourserequests',
        name: 'AdminCourseRequests',
        component: () => import(/* webpackChunkName: "profile" */ '@/views/AdminCourseRequests.vue'),
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
    meta: {
      layout: 'layout-full',
    },
  },
  { path: '*', redirect: '/' },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

const adminRouteNames = [
  "Login", "AdminCourses", "AdminCoupons", "AdminFiles", "AdminQuotes", "AdminBooksBank", "AdminVideosBank", "AdminQuestionsBank", "AdminUsers", "AdminUpdateExerciseLaws",
  "AdminUpdateVideoContent", "AdminUpdateLawCollections", "AdminUnitReplication", "AdminVerdictReplication", "AdminCreateAnswersFiles", "AdminCreateQuestionsFiles", "AdminVerdictsCollections",
  "AdminManageLawsCollections", "Question", "NewQuestion", "LawCollection", "AdminManageQuestionsCategories"
];

router.beforeEach((to, from, next) => {
  if (to.meta.ignoreLogin) {
    return next();
  }

  const proceed = () => {
    // Course-scoped routes need a course selected in THIS tab. The course lives
    // in sessionStorage (per-tab), so a freshly opened tab/window can be logged
    // in with no course yet. Send those to the course picker instead of letting
    // a course-scoped view mount with a null course and crash.
    // General admin pages (in adminRouteNames, or anything under /admin) are
    // course-independent and must NOT be gated.
    const isCourseFree = adminRouteNames.includes(to.name) || to.path.startsWith('/admin');
    if (!isCourseFree && !store.state.auth.course?.id) {
      return next({ name: 'AdminCourses' });
    }
    return next();
  };

  if (to.name === 'Login') { // check if "to"-route is "callback" and allow access
    return router.app.$auth.isAuthenticated() ? next(false) : next();
  }
  if (router.app.$auth.isAuthenticated()) { // if authenticated allow access
    return proceed();
  }
  // trigger auth login
  return router.app.$auth.login()
    .then(() => proceed())
    .catch(() => router.push({ name: 'Login' }));
});

export default router;
